import { render, staticRenderFns } from "./liveWalletUserRecord.vue?vue&type=template&id=04a7c22b&scoped=true&"
import script from "./liveWalletUserRecord.vue?vue&type=script&lang=js&"
export * from "./liveWalletUserRecord.vue?vue&type=script&lang=js&"
import style0 from "./liveWalletUserRecord.vue?vue&type=style&index=0&id=04a7c22b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a7c22b",
  null
  
)

export default component.exports